import "./iframe.pcss";

const youtubePlaceholders = document.querySelector("lite-youtube");
const vimeoPlaceholders = document.querySelector("lite-vimeo");
if (youtubePlaceholders || vimeoPlaceholders) {
    import(/* webpackChunkName: "iframe-lazy" */ "./lazy.js");
}
